import JSDB from "../fromKotlin/nk";
import {roundDecimals} from "../fromKotlin/nkutils";


export const deserializeInventory = (c,zero): InventoryItem => {

    // Product can be null when an inventory record points at a deleted/inactive
    // product that isn't in the store. Guard so one stale row doesn't crash the
    // whole inventory list (was an unguarded null deref before).
    const p = JSDB().getClientProduct(c.product_id).first;
    const user = JSDB().getAgentBy(c.agent_id, null,false,false,false,true).first;
    let unit1 = p?.getUnitName() ?? '';
    if (unit1 == '') {
        unit1 = 'יח\'';
    }
    let unit2 = undefined;
    const unitTemp = p?.getOrderProduct()?.getExtraUnitName()
    if (unitTemp != null && unitTemp != '') {
       unit2=unitTemp
    }

    const cost = JSDB().getProductCost(c.product_id)?.get()
    let totalCost = (cost?.first ?? 0) * (1 - (cost?.second ?? 0) / 100)
    const position = p?.position ?? 0;

    return {
        id: c.product_id,
        external_id: p?.external_id ?? '',
        name: p?.name ?? `מוצר ${c.product_id}`,
        barcode: p?.barcode ?? '',
        position: (c?.valueSumSec ||  c?.valueSum)  ?  -5000+position : position,
        user: user?.user_name?? 'כללי',
        user_type: user?.getDescription() ?? 'כללי',
        user_id: c.agent_id ?? -1,
        totalCost:roundDecimals(totalCost),
        inventoryStart:roundDecimals(zero ? 0 : (c?.inventoryStart ?? 0),2),
        inventoryStart2: roundDecimals(zero ? 0 :(c?.inventoryStart2 ?? 0),2),
        amountDistribution:  roundDecimals(c?.amountDistribution ?? 0,2),
        amountDistribution2: roundDecimals(c?.amountDistribution2 ?? 0,2),
        totalInventory: roundDecimals(c?.valueSum  ?? 0,2),
        totalInventory2: roundDecimals(c?.valueSumSec  ?? 0,2) ,
        inventoryMatch: roundDecimals(c?.inventoryMatch ?? 0,2),
        inventoryMatchSec: roundDecimals(c?.inventoryMatchSec ?? 0,2),
        inventoryLast: roundDecimals(c?.lastInventory ?? 0,2),
        inventoryLastSec: roundDecimals(c?.lastInventorySec ?? 0,2),
        unit1: unit1,
        unit2: unit2,
        nkObject: c

    }
};

export const serializeInventory = (c: InventoryItem) => {
    return {
        product_id: c.id,
        inventoryStart: isNaN(c.inventoryStart) ? 0 : c.inventoryStart,
        inventoryStart2: isNaN(c.inventoryStart2) ? 0 : c.inventoryStart2,
        amountDistribution: c.amountDistribution,
        amountDistribution2: c.amountDistribution2,
        valueSum: c.totalInventory,
        valueSumSec: c.totalInventory2,
        agent_id: c.user_id
    }
}

interface InventoryItem {
    id: number;
    external_id?: string;
    name: string
    barcode: string
    user: string
    user_id?: number
    position: number
    user_type?: string
    totalCost? :number
    inventoryStart: number
    inventoryStart2: number
    amountDistribution: number
    amountDistribution2: number
    totalInventory: number
    totalInventory2: number
    inventoryMatch?:number
    inventoryMatchSec?:number
    inventoryLast?:number
    inventoryLastSec?:number
    unit1?: string
    unit2?: string
    nkObject: any;

}

export default InventoryItem;
